import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastComponent } from './toast.component';
import { TranslationModule } from 'src/app/i18n/translation.module';
import { DirectivesModule } from '../directives/directives.module';
import { SvgModule } from '../svg/svg.module';



@NgModule({
  declarations: [
    ToastComponent
  ],
  imports: [
    CommonModule,
    TranslationModule,
    DirectivesModule,
    SvgModule
  ],
  exports: [ToastComponent]
})
export class ToastModule { }
